module.exports = __webpack_public_path__ + "img/KEN_IGBP2019.5a035d50.jpg";